import React from 'react'
import { Nav } from '../components/Nav/Nav'

export const Home = ({handleContactClick}) => {
    return (
        <div>
           <Nav handleContactClick={handleContactClick} />
        </div>
    )
}